import { LorebookEntryStatus } from "@next-platform/packages-ts-types";
export default function buildGetLorebookByIdUrl({ baseUrl, lastEntryId, lastSortPriority, search, entryStatus, view, }) {
    const queryParams = new URLSearchParams();
    queryParams.set("sortBy", "priority");
    const trimmedSearch = search?.trim();
    const isSearchActive = Boolean(trimmedSearch);
    if (isSearchActive) {
        // Pass the query as-is since DynamoDB contains is case-sensitive. Lowercasing it here breaks exact matches.
        queryParams.set("search", trimmedSearch);
    }
    else {
        if (lastSortPriority !== undefined) {
            queryParams.set("lastSortPriority", String(lastSortPriority));
        }
        if (lastEntryId) {
            queryParams.set("lastEntryId", lastEntryId);
        }
    }
    if (entryStatus && entryStatus.length > 0) {
        entryStatus.forEach((status) => {
            queryParams.append("entryStatus", status);
        });
    }
    if (view) {
        queryParams.set("view", view);
    }
    return `${baseUrl}?${queryParams.toString()}`;
}
